/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { useContext } from 'react';

// Context
import { WorkspaceLayoutContext } from '@layouts/WorkspaceLayout/context';

// Types
import { CurrentWorkspace } from '@layouts/WorkspaceLayout/types';

/* -------------------------------------------------------------------------- */
/*                                    Hook                                    */
/* -------------------------------------------------------------------------- */

/**
 * Returns current workspace from context, or undefined if outside WorkspaceLayoutProvider.
 * Use this in shared components that can render both inside and outside a workspace.
 * For components guaranteed to be inside WorkspaceLayoutProvider, use useWorkspace() instead.
 * @returns {CurrentWorkspace | undefined} Current workspace or undefined
 */
function useOptionalWorkspace(): CurrentWorkspace | undefined {
  const { workspace } = useContext(WorkspaceLayoutContext);
  return workspace;
}

export default useOptionalWorkspace;
